export type SoundType = 'success' | 'error' | 'celebration';

const SOUND_ENABLED_KEY = 'resume_doctor_sound_enabled';

export class AudioManager {
  private audioContext: AudioContext | null = null;
  private enabled: boolean;

  constructor() {
    this.enabled = this.loadSoundPreference();
  }

  private loadSoundPreference(): boolean {
    const stored = localStorage.getItem(SOUND_ENABLED_KEY);
    return stored === null ? true : stored === 'true';
  }

  public isEnabled(): boolean {
    return this.enabled;
  }

  public setEnabled(enabled: boolean): void {
    this.enabled = enabled;
    localStorage.setItem(SOUND_ENABLED_KEY, enabled.toString());
  }

  private getAudioContext(): AudioContext {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    return this.audioContext;
  }

  private playTone(frequency: number, duration: number, volume: number = 0.3): void {
    if (!this.enabled) return;

    try {
      const ctx = this.getAudioContext();
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);

      oscillator.frequency.value = frequency;
      oscillator.type = 'sine';

      gainNode.gain.setValueAtTime(volume, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration);

      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + duration);
    } catch (error) {
      console.warn('Audio playback failed:', error);
    }
  }

  public playSuccess(): void {
    if (!this.enabled) return;

    this.playTone(523.25, 0.1, 0.2);
    setTimeout(() => this.playTone(659.25, 0.15, 0.2), 100);
  }

  public playError(): void {
    if (!this.enabled) return;

    this.playTone(329.63, 0.2, 0.25);
    setTimeout(() => this.playTone(293.66, 0.25, 0.25), 150);
  }

  public playCelebration(): void {
    if (!this.enabled) return;

    this.playTone(523.25, 0.15, 0.2);
    setTimeout(() => this.playTone(659.25, 0.15, 0.2), 100);
    setTimeout(() => this.playTone(783.99, 0.2, 0.2), 200);
    setTimeout(() => this.playTone(1046.50, 0.25, 0.2), 350);
  }

  public play(type: SoundType): void {
    switch (type) {
      case 'success':
        this.playSuccess();
        break;
      case 'error':
        this.playError();
        break;
      case 'celebration':
        this.playCelebration();
        break;
    }
  }
}

export const audioManager = new AudioManager();
